import './record-mask-display.scss'

import { faCaretDown, faCaretRight } from '@fortawesome/free-solid-svg-icons';
import { get, set } from 'lodash';
import { Component, Watch } from 'vue-property-decorator';

import { ReactiveVue } from '@skinsoft/reactive-vue';
import { CollapsibleSection, getTranslatedString } from '@skinsoft/ui';

import { EntityField } from '@skinsoft/data-store';
import { REPORT_EDITOR_CLOSE_ALL_TABS_TOPIC, REPORT_EDITOR_OPEN_ALL_TABS_TOPIC } from '../../../../../../apps/condition-report/src/busTopics';
import { MetaRecordMaskDataStore } from '../../meta-record-mask-data-store';
import { RecordMask, RecordMaskCategory, RecordMaskDataStore } from '../../record-mask-data-store';
import { MaskField } from '../mask-field';
import { MediasFieldsArea } from '../../../../../../apps/condition-report/src/app/report-edition/medias-fields-area';
@Component({
    components: {
        sCollapsibleSection: CollapsibleSection,
        sMediasFieldsArea: MediasFieldsArea,
        sMaskField: MaskField,
    },
    props: ['recordMask', 'entity', 'isMetaMask', 'forceReadonly'],
    template: require('./record-mask-display.html')
})
export class RecordMaskDisplay extends ReactiveVue {

    public entity: any;
    public isMetaMask: boolean;
    public forceReadonly: boolean;
    public recordMask: RecordMask;

    // Icons
    public caretRightIcon = faCaretRight;
    public caretDownIcon = faCaretDown;


    private $recordMaskDataStore: RecordMaskDataStore;
    private $metaRecordMaskDataStore: MetaRecordMaskDataStore;

    public onCollapseAllClick() {
        this.emitOnBus(REPORT_EDITOR_CLOSE_ALL_TABS_TOPIC);
    }

    public onDeployAllClick() {
        this.emitOnBus(REPORT_EDITOR_OPEN_ALL_TABS_TOPIC)
    }

    private getCategoryLabel(category: RecordMaskCategory) {
        if (category.label) {
            const label = getTranslatedString(category.label, this.$i18n.locale)
            return label;
        }
        return ""
    }

    private updateValue(updateEvent) {
        this.$emit('value-change', { ...updateEvent, subWemi: this.getSubWemi(updateEvent.abstractEntity) })
    }

    /**
     * Return the name of the subfield of 'this.entity' corresponding
     * to the right wemi part for a given entityField
     * @param entityField 
     */
    private getSubWemi(abstractEntity: string) {
        switch (abstractEntity) {
            case "museumItem":
                return "item";
            case "museumManifestation":
                return "manifestation";
            case "work":
                return "work";
            case "expression":
                return "expression";
            default:
                return null
        }

    }

    private getFieldValue(entityField: EntityField) {
        if (this.isMetaMask) {
            const subWemi = this.getSubWemi(entityField.abstractEntity);
            return get(this.entity, `${subWemi}.${entityField.path}`)
        }
        else {
            return get(this.entity, entityField.path)
        }
    }

    public get associatedMediasFieldName() {
        return `associatedMedias`
    }

    public get itemForMediaArea(){
        if(this.entity.item){
            return this.entity.item;
        }
        return this.entity;
    }

    public onAddMedia(media) {
        this.$emit('addMedia', media)
    }

    public onImageChoice(media) {
        this.$emit('imageChoice', media)
    }
}